(function () {
  if (window.__mpefCartLoaded) return;
  window.__mpefCartLoaded = true;

  var PER = 3;
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="1"/><path d="M3 12h18M12 8v13M12 8S9 3 6.5 4.5 9 8 12 8zM12 8s3-5 5.5-3.5S15 8 12 8z"/></svg>';
  var CHECK = '<svg class="mpef-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path class="mpef-check-mark" d="M8 12l3 3 5-6"/></svg>';

  function ensureStyle() {
    if (document.getElementById('mpef-cart-style')) return;
    var s = document.createElement('style'); s.id = 'mpef-cart-style';
    s.textContent =
      '#mpef-cart-progress{padding:14px 16px;margin:0 1.5rem 12px;background:#f7efef;border:1px solid #e3cece;border-radius:4px;}' +
      '#mpef-cart-progress .mpef-cp-msg{display:flex;align-items:center;justify-content:center;gap:7px;text-align:center;font-size:12.5px;font-weight:600;color:#121212;letter-spacing:.02em;margin-bottom:9px;line-height:1.4;}' +
      '#mpef-cart-progress .mpef-cp-col{flex-direction:column;gap:3px;}' +
      '#mpef-cart-progress .mpef-cp-l2{display:inline-flex;align-items:center;gap:6px;}' +
      '#mpef-cart-progress .mpef-cp-msg svg{width:16px;height:16px;flex-shrink:0;color:#937879;}' +
      '#mpef-cart-progress .mpef-check{transform-origin:center;animation:mpef-check-pop .55s cubic-bezier(.2,.7,.3,1.5) both;}' +
      '#mpef-cart-progress .mpef-check circle{stroke-dasharray:58;stroke-dashoffset:58;animation:mpef-check-circle .5s ease .05s forwards;}' +
      '#mpef-cart-progress .mpef-check-mark{stroke-dasharray:14;stroke-dashoffset:14;animation:mpef-check-draw .4s cubic-bezier(.6,0,.3,1) .35s forwards;}' +
      '@keyframes mpef-check-pop{0%{transform:scale(.3);opacity:0;}60%{transform:scale(1.15);}100%{transform:scale(1);opacity:1;}}' +
      '@keyframes mpef-check-circle{to{stroke-dashoffset:0;}}' +
      '@keyframes mpef-check-draw{to{stroke-dashoffset:0;}}' +
      '#mpef-cart-progress .mpef-cp-track{height:6px;background:#e3cece;border-radius:999px;overflow:hidden;}' +
      '#mpef-cart-progress .mpef-cp-fill{height:100%;background:#937879;border-radius:999px;transition:width .5s ease;}' +
      '.mpef-drawer-upsell{padding:14px 1.5rem 2px;border-top:1px solid rgba(0,0,0,.08);}' +
      '.mpef-du-head{font-size:11px;text-transform:uppercase;letter-spacing:1.5px;color:#937879;margin:0 0 11px;font-weight:600;}' +
      '.mpef-du-head.mpef-du-head-feat{color:#121212;display:flex;align-items:center;gap:6px;}' +
      '.mpef-du-head.mpef-du-head-feat svg{width:14px;height:14px;color:#937879;flex-shrink:0;}' +
      '.mpef-du-group + .mpef-du-group{margin-top:14px;padding-top:12px;border-top:1px dashed rgba(0,0,0,.1);}' +
      '.mpef-du-row{display:flex;align-items:center;gap:11px;margin-bottom:11px;}' +
      '.mpef-du-row img{width:46px;height:46px;object-fit:cover;border-radius:3px;flex-shrink:0;}' +
      '.mpef-du-meta{flex:1;min-width:0;}' +
      '.mpef-du-name{display:block;font-size:12.5px;line-height:1.25;color:inherit;text-decoration:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
      '.mpef-du-price{font-size:12px;font-weight:600;}' +
      '.mpef-du-form{margin:0;flex-shrink:0;}' +
      '.mpef-du-add{width:30px;height:30px;border-radius:50%;border:1px solid #121212;background:#fff;color:#121212;font-size:17px;line-height:1;cursor:pointer;transition:background .2s,color .2s;display:flex;align-items:center;justify-content:center;padding:0;}' +
      '.mpef-du-add:hover{background:#121212;color:#fff;}' +
      'cart-drawer .quantity__button[name="plus"]{opacity:.25;pointer-events:none;}' +
      '.mpef-flash{animation:mpef-flash 1.1s ease;}' +
      '@keyframes mpef-flash{0%,100%{background:transparent;}30%{background:rgba(147,120,121,.14);}}' +
      'body.mpef-drawer-open .mp-sticky{display:none !important;}' +
      '@media (prefers-reduced-motion: reduce){#mpef-cart-progress .mpef-check,#mpef-cart-progress .mpef-check circle,#mpef-cart-progress .mpef-check-mark{animation:none;stroke-dashoffset:0;}}';
    document.head.appendChild(s);
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function renderBanner(cart) {
    var drawer = drawerEl(); if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner'); if (!inner) return;
    var count = cart ? cart.item_count : 0;
    var ex = document.getElementById('mpef-cart-progress');
    if (!count) { if (ex) ex.remove(); return; }
    var rem = count % PER, need = rem === 0 ? 0 : PER - rem;
    var msgHtml, pct;
    if (need === 0) {
      pct = 100;
      msgHtml = '<span class="mpef-cp-msg mpef-cp-col"><span>Bravo !</span><span class="mpef-cp-l2">' + CHECK + '<span>Votre article le moins cher vous est offert.</span></span></span>';
    } else {
      pct = Math.round(rem / PER * 100);
      var txt = 'Plus que ' + need + ' article' + (need > 1 ? 's' : '') + ' pour recevoir le 3ème offert';
      msgHtml = '<span class="mpef-cp-msg">' + GIFT + '<span>' + txt + '</span></span>';
    }
    var html = msgHtml + '<div class="mpef-cp-track"><div class="mpef-cp-fill" style="width:' + pct + '%"></div></div>';
    if (ex) {
      if (ex.getAttribute('data-state') === String(need === 0)) { ex.innerHTML = html; }
      else { ex.setAttribute('data-state', String(need === 0)); ex.innerHTML = html; }
      return;
    }
    var b = document.createElement('div'); b.id = 'mpef-cart-progress'; b.setAttribute('data-state', String(need === 0)); b.innerHTML = html;
    var anchor = inner.querySelector('cart-drawer-items') || inner.querySelector('.drawer__contents') || inner.querySelector('form');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(b, anchor); else inner.insertBefore(b, inner.firstChild);
  }

  function enforceSingle() {
    var drawer = drawerEl(); if (!drawer) return;
    drawer.querySelectorAll('.quantity__input').forEach(function (inp) { inp.setAttribute('max', '1'); inp.setAttribute('readonly', 'readonly'); });
    drawer.querySelectorAll('.quantity__button[name="plus"]').forEach(function (b) { b.setAttribute('disabled', 'disabled'); b.setAttribute('tabindex', '-1'); });
  }

  function inCart(cart, id) { return cart && cart.items && cart.items.some(function (it) { return String(it.variant_id) === String(id); }); }

  function cartProductIds(cart) { return (cart && cart.items ? cart.items : []).map(function (it) { return String(it.product_id); }); }

  function fmtMoney(cents) {
    if (typeof cents !== 'number') return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function rowHtml(p) {
    return '<div class="mpef-du-row">' +
      (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') +
      '<div class="mpef-du-meta"><a class="mpef-du-name" href="' + p.url + '">' + p.title + '</a><span class="mpef-du-price">' + p.price + '</span></div>' +
      '<form class="mp-ajax-cart mpef-du-form" action="' + addUrl + '" method="post"><input type="hidden" name="id" value="' + p.id + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="mpef-du-add" aria-label="Ajouter">+</button></form>' +
      '</div>';
  }

  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.8 6.1 20.8l1.2-6.6L2.5 9l6.6-.9z"/></svg>';

  // groups: [{ head, feat (bool), picks:[] }]
  function renderUpsell(cart, groups) {
    var drawer = drawerEl(); if (!drawer) return;
    var old = drawer.querySelector('.mpef-drawer-upsell'); if (old) old.remove();
    var live = (groups || []).filter(function (g) { return g.picks && g.picks.length; });
    if (!live.length) return;
    var html = live.map(function (g) {
      var head = '<div class="mpef-du-head' + (g.feat ? ' mpef-du-head-feat' : '') + '">' + (g.feat ? STAR : '') + '<span>' + g.head + '</span></div>';
      return '<div class="mpef-du-group">' + head + g.picks.map(rowHtml).join('') + '</div>';
    }).join('');
    var box = document.createElement('div'); box.className = 'mpef-drawer-upsell';
    box.innerHTML = html;
    var footer = drawer.querySelector('.drawer__footer') || drawer.querySelector('.cart-drawer__footer');
    if (footer && footer.parentNode) footer.parentNode.insertBefore(box, footer);
    else { var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.appendChild(box); }
  }

  function picksFromProducts(cart, prods, excludePids) {
    var inc = cartProductIds(cart), out = [];
    excludePids = excludePids || [];
    for (var i = 0; i < prods.length && out.length < 2; i++) {
      var p = prods[i];
      if (!p || inc.indexOf(String(p.id)) !== -1) continue;
      if (excludePids.indexOf(String(p.id)) !== -1) continue;
      if (p.available === false) continue;
      var vars = p.variants || [];
      var v = vars.filter(function (x) { return x.available; })[0] || vars[0];
      if (!v) continue;
      out.push({ id: v.id, pid: p.id, title: p.title, url: p.url, img: p.featured_image, price: fmtMoney(p.price) });
    }
    return out;
  }

  function picksFromStatic(cart) {
    var data = document.getElementById('mpef-upsell-data');
    if (!data) return [];
    var list; try { list = JSON.parse(data.textContent); } catch (e) { return []; }
    if (!list || !list.length) return [];
    return list.filter(function (p) { return !inCart(cart, p.id); }).slice(0, 2);
  }

  function picksFromFeatured(cart) {
    var data = document.getElementById('mpef-featured-data');
    if (!data) return [];
    var list; try { list = JSON.parse(data.textContent); } catch (e) { return []; }
    if (!list || !list.length) return [];
    return list.filter(function (p) { return !inCart(cart, p.id); }).slice(0, 2);
  }

  function recUrl(pid, intent) {
    return shopRoot.replace(/\/$/, '') + '/recommendations/products.json?limit=10&intent=' + intent + '&product_id=' + pid;
  }
  function fetchRecs(pid, intent) {
    return fetch(recUrl(pid, intent), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  function injectUpsell(cart) {
    var drawer = drawerEl(); if (!drawer) return;
    var old = drawer.querySelector('.mpef-drawer-upsell'); if (old) old.remove();
    if (!cart || !cart.item_count || !cart.items || !cart.items.length) return;

    var data = document.getElementById('mpef-upsell-data');
    var title = (data && data.getAttribute('data-title')) || 'Ajoutez à votre commande';
    var fdata = document.getElementById('mpef-featured-data');
    var ftitle = (fdata && fdata.getAttribute('data-title')) || 'Nos incontournables des fêtes';

    var featured = picksFromFeatured(cart);
    var fpids = featured.map(function (f) { return String(f.pid); });
    var featGroup = { head: ftitle, feat: true, picks: featured };

    function paint(compPicks) { renderUpsell(cart, [featGroup, { head: title, picks: compPicks || [] }]); }

    // Show the featured products straight away, then fill complementary when ready
    renderUpsell(cart, [featGroup]);

    var anchor = cart.items[cart.items.length - 1];
    var pid = anchor && anchor.product_id;
    if (!pid) { paint(picksFromStatic(cart)); return; }

    var token = String(cart.item_count) + ':' + String(pid);
    drawer.setAttribute('data-upsell-token', token);
    fetchRecs(pid, 'complementary').then(function (prods) {
      if (drawer.getAttribute('data-upsell-token') !== token) return;
      var picks = picksFromProducts(cart, prods, fpids);
      if (picks.length) { paint(picks); return; }
      return fetchRecs(pid, 'related').then(function (p2) {
        if (drawer.getAttribute('data-upsell-token') !== token) return;
        var pk2 = picksFromProducts(cart, p2, fpids);
        if (pk2.length) { paint(pk2); return; }
        paint(picksFromStatic(cart));
      });
    });
  }

  function apply(cart) { ensureStyle(); renderBanner(cart); enforceSingle(); injectUpsell(cart); }

  function refresh() {
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { apply(c); return c; })
      .catch(function () {});
  }
  window.mpefCartRefresh = refresh;

  function flash(id) {
    var drawer = drawerEl(); if (!drawer) return;
    var el = drawer.querySelector('[data-variant-id="' + id + '"]') || drawer.querySelector('.cart-item');
    if (el) { el.classList.add('mpef-flash'); setTimeout(function () { el.classList.remove('mpef-flash'); }, 1200); }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('mp-ajax-cart')) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? String(idInput.value) : null;
    var drawer = drawerEl();
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.style.opacity = '0.6'; }
    function done() { if (btn) { btn.removeAttribute('disabled'); btn.style.opacity = ''; btn.innerHTML = orig; } }

    fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (variantId && inCart(cart, variantId)) {
          if (drawer && typeof drawer.open === 'function') { drawer.open(); }
          refresh().then(function () { flash(variantId); });
          done();
          return;
        }
        var fd = new FormData(form);
        if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
        return fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status) { window.location = cartUrl; return; }
            if (drawer && res.sections && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(res); setTimeout(refresh, 90); }
            else { window.location = cartUrl; }
            done();
          });
      })
      .catch(function () { window.location = cartUrl; });
  });

  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('cart-drawer .quantity__button[name="plus"]');
    if (plus) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  function watch() {
    var drawer = drawerEl(); if (!drawer) return;
    function syncOpen() { document.body.classList.toggle('mpef-drawer-open', drawer.classList.contains('active')); }
    new MutationObserver(function () { syncOpen(); if (drawer.classList.contains('active')) { setTimeout(refresh, 60); } })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncOpen();
    drawer.addEventListener('click', function (e) { if (e.target.closest('.cart-remove-button, cart-remove-button, .quantity__button')) { setTimeout(refresh, 400); } });
    drawer.addEventListener('change', function () { setTimeout(refresh, 400); });
  }

  if (document.readyState !== 'loading') { watch(); refresh(); }
  else document.addEventListener('DOMContentLoaded', function () { watch(); refresh(); });
})();